const Rebooking = {
  createRebooking: `Rebooking/CreateRebooking`,
  getCreditInformations: (bookingId: number | string | null, tickets: string[] | null | undefined, type: any = 2) =>
    `Refund/Penalties?BookingId=${bookingId}&Type=${type}&${tickets}`,
  removeBooking: (bookingId: number | string, ticket: number | null) =>
    `Refund/Penalties?BookingId=${bookingId}&Type=5&TicketNumbers=${ticket}`,
  getRebookingBuyerPassenger: `Agency/Rebooking/GetRebookingBuyerPassenger`,
  paymentRebooking: `/Agency/Rebooking`,
};

export default Rebooking;
